module.exports = __webpack_public_path__ + "media/components/assets/icons/rank/top1-3440c174d70d5c576f6e35f4f615276b.svg";